import React from 'react';
import {
    WORKOUT_REPS_MODE_OPTIONS,
    normalizeWorkoutRepsMode,
} from '../../../constants/workoutRepsMode';

const inputClass =
    'w-full px-2 py-1 text-xs border border-gray-300 rounded bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:focus:border-indigo-500 dark:focus:ring-white/30';

/**
 * WEBAPP-15: reps fisso / range / cedimento per righe template (usa ripetizioni_min/max).
 */
export default function TemplateRepsInputs({ exercise, onUpdate }) {
    const isCardio = exercise.is_cardio === 1 || exercise.is_cardio === true;
    const isIsometric = exercise.is_isometric_scheda === 1 || exercise.is_isometric_scheda === true;

    if (isCardio) {
        return (
            <div>
                <label className="text-xs text-gray-500 dark:text-gray-400">Minuti</label>
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni_max ?? ''}
                    onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                    className={inputClass}
                />
            </div>
        );
    }

    if (isIsometric) {
        return (
            <div>
                <label className="text-xs text-gray-500 dark:text-gray-400">⏱️ Secondi</label>
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni_max ?? ''}
                    onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                    className={inputClass}
                />
            </div>
        );
    }

    const repsMode = normalizeWorkoutRepsMode(exercise.reps_mode);

    const handleModeChange = (mode) => {
        onUpdate('reps_mode', mode);
        if (mode === 'fixed') {
            onUpdate('ripetizioni_min', 0);
            if (!exercise.ripetizioni_max) onUpdate('ripetizioni_max', 12);
        } else if (mode === 'range') {
            onUpdate('ripetizioni_min', exercise.ripetizioni_min ?? 8);
            onUpdate('ripetizioni_max', exercise.ripetizioni_max ?? 12);
        } else if (mode === 'amrap') {
            onUpdate('ripetizioni_min', 0);
            onUpdate('ripetizioni_max', 0);
        }
    };

    return (
        <div className="col-span-2 space-y-1">
            <label className="text-xs text-gray-500 dark:text-gray-400">Ripetizioni</label>
            <select
                value={repsMode}
                onChange={(e) => handleModeChange(e.target.value)}
                className={inputClass}
            >
                {WORKOUT_REPS_MODE_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
            </select>

            {repsMode === 'fixed' && (
                <input
                    type="number"
                    min="1"
                    value={exercise.ripetizioni_max ?? ''}
                    onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                    className={inputClass}
                    placeholder="Es. 12"
                />
            )}

            {repsMode === 'range' && (
                <div className="grid grid-cols-2 gap-2">
                    <input
                        type="number"
                        min="1"
                        value={exercise.ripetizioni_min ?? ''}
                        onChange={(e) => onUpdate('ripetizioni_min', parseInt(e.target.value, 10) || '')}
                        className={inputClass}
                        placeholder="Min"
                    />
                    <input
                        type="number"
                        min="1"
                        value={exercise.ripetizioni_max ?? ''}
                        onChange={(e) => onUpdate('ripetizioni_max', parseInt(e.target.value, 10) || '')}
                        className={inputClass}
                        placeholder="Max"
                    />
                </div>
            )}

            {repsMode === 'amrap' && (
                <p className="text-xs italic text-gray-500 dark:text-gray-400">A cedimento</p>
            )}
        </div>
    );
}
